import { app } from '../../bootstrap/core';
import { finishState } from './finish.state';
import { finishComponent } from './finish.component';
import { FinishService } from './finish.service';

app.config(finishState);
app.component(finishComponent.name, finishComponent);
app.service('finishService', FinishService);



// WEBPACK FOOTER //
// ./src/app/components/finish/finish.js